// extracted by mini-css-extract-plugin
module.exports = {"overview":"OrderOverview_overview__26AaZ"};